<ng-container *ngIf="userService.hasLoggedInUserAccess({type: 'users', customerId: ''})">
    <div class="columns">
        <div class="column">
            <button *ngIf="isUserAdmin()" (click)="showUserModal()" class="button">
                Benutzer anlegen
            </button>
        </div>
    </div>
    <div class="columns is-hidden-mobile">
        <div class="column has-text-weight-bold">Benutzername</div>
        <div class="column has-text-weight-bold">E-Mail</div>
        <div class="column has-text-weight-bold has-text-right-tablet">Rechte des Benutzers</div>
        <div class="column has-text-weight-bold has-text-right-tablet">Benutzer bearbeiten</div>
    </div>
    <div class="columns" *ngFor="let item of users; let i = index;">
        <div class="column"><span class="is-hidden-tablet">Benutzername: </span>{{ item.username }}</div>
        <div class="column"><span class="is-hidden-tablet">E-Mail: </span>{{ item.email }}</div>
        <div class="column has-text-right-tablet container-grant">
            <span class="is-hidden-tablet">Rechte des Benutzers: </span>
            <fa-icon [icon]="faUsersCog" pTooltip="Administrator" tooltipPosition="left" [class]="isGrantByCustomer(item.shopAccessForCustomers, 'users') ? 'active' : ''"
                     class="icon is-size-6 mr-2"></fa-icon>
            <fa-icon [icon]="faFileInvoice" pTooltip="Rechnungen einsehen" tooltipPosition="left" [class]="isGrantByCustomer(item.shopAccessForCustomers, 'invoices') ? 'active' : ''"
                     class="icon is-size-6 mr-2"></fa-icon>
            <fa-icon [icon]="faMoneyBillAlt" pTooltip="Preise einsehen" tooltipPosition="left" [class]="isGrantByCustomer(item.shopAccessForCustomers, 'prices') ? 'active' : ''"
                     class="icon is-size-6 mr-2"></fa-icon>
            <fa-icon [icon]="faStar" pTooltip="Favoriten bearbeiten" tooltipPosition="left" [class]="isGrantByCustomer(item.shopAccessForCustomers, 'favorites') ? 'active' : ''"
                     class="icon is-size-6"></fa-icon>
        </div>
        <div class="column has-text-right-tablet">
            <fa-icon *ngIf="isUserAdmin() || (user$ | async)?.id == item.id" (click)="showUserModal(item.id)" [icon]="faEdit" pTooltip="Benutzer bearbeiten"
                     tooltipPosition="left" class="is-pointer"></fa-icon>
            <fa-icon
                    *ngIf="isUserAdmin() && ((user$ | async)?.id != item.id || isThereMoreThenOneAdmin())"
                    (click)="deleteUser(item.username)" [icon]="faTrash" pTooltip="Benutzer löschen"
                    tooltipPosition="left" class="is-pointer ml-4"></fa-icon>

        </div>
    </div>
</ng-container>


<!-- MODAL SET/EDIT USER -->
<div *ngIf="userModal" class="modal is-large is-active">
    <form [formGroup]="form">


        <div class="modal-background"></div>
        <div class="modal-card">
            <header class="modal-card-head">
                <p class="modal-card-title">
                    <span *ngIf="!isUserId()">Benutzer anlegen</span>
                    <span *ngIf="isUserId()">Benutzer bearbeiten</span>



                </p>
                <a class="delete" (click)="userModal = false"></a>
            </header>
            <section class="modal-card-body">
                <article *ngIf="apiError && apiError.notification !== 'username exist'" class="message is-danger">
                    <div class="message-body">
                        <b>{{ apiError.notification }}</b>
                        <span *ngFor="let error of apiError.errors" class="is-block">{{ error.key }}: {{ error.error }}</span>
                    </div>
                </article>
                <div class="columns">
                    <div class="column">
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label class="label">Benutzername*</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <div class="control">
                                        <input class="input" type="text" placeholder="Benutzername" formControlName="username"  [ngClass]="isFormRequestError('username') ? 'is-danger' : ''" >
                                        <p *ngIf="isFormRequestError('username')" class="help is-danger">Bitte hinterlegen Sie einen Benutzernamen.</p>
                                        <p *ngIf="apiError?.notification == 'username exist'" class="help is-danger">Der Benutzername existiert bereits im System.</p>
                                    </div>
                                    <p class="help">
                                        Der Benutzername wird für das Login benötigt. Als Benutzername kann eine
                                        E-Mail-Adresse hinterlegt werden.
                                    </p>
                                </div>
                            </div>
                        </div>
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label class="label">E-Mail*</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <div class="control">
                                        <input class="input" type="email" placeholder="E-Mail" formControlName="email" [ngClass]="isFormRequestError('email') ? 'is-danger' : ''">
                                        <p *ngIf="isFormRequestError('email')" class="help is-danger">Bitte hinterlegen Sie eine E-Mail.</p>
                                    </div>
                                    <p class="help">
                                        Die Bestellbestätigungen werden an die hinterlegte E-Mail-Adresse gesendet.
                                    </p>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label class="label">Benutzerrechte</label>
                            </div>
                            <div class="field-body">
                                <div class="mt-2">
                                    <label class="checkbox is-block" *ngFor="let choice of grant; let i=index">
                                        <input
                                                type="checkbox"
                                                [disabled]="(isGrant('users') && choice.value !== 'users') || !isUserAdmin() || (choice.value == 'users' && !isThereMoreThenOneAdmin() && getActiveUserId() == form.get('userId')?.value )"
                                                [checked]="isGrant(choice.value)"
                                                (change)="changeGrant(choice.value)"
                                        />
                                        <span><fa-icon [icon]="choice.iconClass"
                                                       class="icon is-size-6 mr-1 ml-1 active"></fa-icon></span>{{ choice.name }}
                                    </label>
                                </div>
                            </div>

                        </div>

                    </div>
                </div>
                <div *ngIf="isUserId()" class="notification is-warning is-light" role="alert">
                    Passwort ausschließlich ausfüllen, wenn Sie dieses neu setzen möchten.
                </div>
                <div class="columns">
                    <div class="column">
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label class="label">Passwort*</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <div class="control">
                                        <input class="input" type="password" placeholder="Passwort" formControlName="password" [ngClass]="isFormRequestError('password') ? 'is-danger' : ''">
                                        <p *ngIf="isFormRequestError('password')" class="help is-danger">Bitte hinterlegen Sie ein Passwort mit mindestens 6 Zeichen.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="columns">
                    <div class="column">
                        <div class="field is-horizontal">
                            <div class="field-label is-normal">
                                <label class="label">Passwort wiederholen*</label>
                            </div>
                            <div class="field-body">
                                <div class="field">
                                    <div class="control">
                                        <input class="input" type="password" placeholder="Passwort wiederholen" formControlName="passwordRetype" [ngClass]="isFormRequestError('passwordRetype') ? 'is-danger' : ''">
                                        <p *ngIf="isFormRequestError('passwordRetype')" class="help is-danger">Die Passwörter stimmen nicht überein.Bitte hinterlegen Sie ein Passwort mit mindestens 6 Zeichen.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="has-text-right">
                    <iw-shop-forms-submit-button *ngIf="!isUserId()"    [formStatus]="formStatus" [submitLabel]="'Benutzer anlegen'"
                                                 (submit)="submit()"></iw-shop-forms-submit-button>
                    <iw-shop-forms-submit-button *ngIf="isUserId()"    [formStatus]="formStatus" [submitLabel]="'Benutzer aktualisieren'"
                                                 (submit)="submit()"></iw-shop-forms-submit-button>
                </div>

            </section>
        </div>
    </form>
</div>



